import React, { useState } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const PhoneVerification = ({
  onBack,
  onSubmit,
  isResuming = false
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const handleSubmit = () => {
    if (phoneNumber.trim().length > 0) {
      onSubmit(phoneNumber);
    }
  };
  const formatPhoneNumber = value => {
    // Keep only digits
    const digits = value.replace(/\D/g, '');
    // Format as (XXX) XXX-XXXX or similar based on length
    let formatted = digits;
    if (digits.length > 3 && digits.length <= 6) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
    } else if (digits.length > 6) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }
    return formatted;
  };
  const handleChange = e => {
    const value = e.target.value;
    setPhoneNumber(formatPhoneNumber(value));
  };
  return <div className="flex flex-col p-6 flex-grow" data-id="element-391">
      <div className="flex items-center mb-6" data-id="element-392">
        <button onClick={onBack} className="mr-4" data-id="element-393">
          <ChevronLeftIcon size={24} data-id="element-394" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-395">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-396"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-397"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-398"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-399"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-400">
        {isResuming ? 'Resume your application' : "Let's verify your phone number."}
      </h1>
      <p className="text-gray-700 mb-6" data-id="element-401">
        {isResuming ? 'Enter the phone number you used previously to continue your application.' : "Enter your phone to continue. We'll send you a verification code. You'll be able to use your phone number to resume your application if needed."}
      </p>
      <div className="mb-6" data-id="element-402">
        <label className="block text-gray-700 mb-2" data-id="element-403">Phone Number</label>
        <input type="tel" value={phoneNumber} onChange={handleChange} placeholder="555-555-5555" className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-404" />
      </div>
      <div className="mt-auto" data-id="element-405">
        <button className={`w-full py-3 rounded-full font-medium ${phoneNumber.trim().length > 0 ? 'bg-[#5c5cf5] text-white' : 'bg-gray-200 text-gray-500'}`} onClick={handleSubmit} disabled={phoneNumber.trim().length === 0} data-id="element-406">
          {isResuming ? 'Resume Application' : 'Next'}
        </button>
      </div>
    </div>;
};